import config from '../config';
import { useAllKitties } from '../hooks/useAllKitties';
import { useTraitShuffleResolver } from '../hooks/useTraitShuffle';
import TraitShufflePreviewImages from './TraitShufflePreviewImages';
import TraitShufflePreviewLayer from './TraitShufflePreviewLayer';
import TraitShuffleRarityKey from './TraitShuffleRarityKey';

const TraitShufflePreview = () => {
  const { allKitties } = useAllKitties();
  const fourthLitter = allKitties.filter((kitty) => kitty.gen === 4);
  useTraitShuffleResolver();

  return (
    <div className='flex flex-col gap-12'>
      <div className='grid grid-cols-1 xl:grid-cols-12 gap-y-8 xl:gap-8'>
        <div className='xl:col-span-6 col-span-1'>
          <TraitShufflePreviewImages />
        </div>

        <div className='xl:col-span-6 col-span-1 flex w-full flex-col gap-4'>
          <div>
            <div className='flex justify-between mb-3'>
              <p className='text-gray-100 text-lg font-medium'>Select a trait category to shuffle</p>
            </div>
            <div className='flex gap-4 flex-col'>
              {config.fourthLitterTraitLayersForShuffle.map((layer) => (
                <TraitShufflePreviewLayer key={layer} layer={layer} allKitties={fourthLitter} />
              ))}
            </div>
          </div>

          <div className='w-full h-px bg-gray-700 mt-12 mb-4' />

          <TraitShuffleRarityKey />
        </div>
      </div>
    </div>
  );
};

export default TraitShufflePreview;
